<custom-modal-card [enableClose]="false" class="company-user-migration-modal">
  <ng-container body>
    <section class="company-user-migration-modal__header">
      <img src="assets/icons/logo.png" alt="Logo FNE" />
      <h2>BIENVENUE SUR LA NOUVELLE PLATEFORME FNE V2 !</h2>
    </section>
    <article class="company-user-migration-modal__content">
      <section class="company-user-migration-modal__greeting">
        <p>
          Cher utilisateur, <br />
          Nous sommes heureux de vous accueillir sur la nouvelle version de la
          plateforme FNE V2, conçue pour vous offrir une expérience améliorée et
          de nouvelles fonctionnalités avantageuses pour votre entreprise.
        </p>
      </section>
      <section class="company-user-migration-modal__notice">
        <h3>Action requise pour finaliser votre accès</h3>
        <p class="highlight">
          Votre compte est actuellement en attente de configuration. Pour
          activer votre accès, le gestionnaire principal de votre entreprise
          doit compléter certaines informations obligatoires dans le cadre de la
          migration.
        </p>

        <p class="note">
          Que devez-vous faire ? Contactez votre gestionnaire principal :
          <strong>{{ managerName() }}</strong> Une fois cette étape finalisée
          par votre gestionnaire, vous recevrez une notification et vous pourrez
          accéder immédiatement à toutes les fonctionnalités de votre compte FNE
          V2.
        </p>
      </section>
      <section class="company-user-migration-modal__help">
        <h4>Besoin d'aide ?</h4>
        <address class="company-user-migration-modal__contact">
          <p>
            📞 Contactez notre support :
            <strong>
              <strong>
                <a
                  href="tel:2521018660"
                  target="_blank"
                  rel="noopener noreferrer"
                  >25 21 01 86 60</a
                >
              </strong>
            </strong>
          </p>
          <p>
            📧 Email :
            <strong>
              <a
                href="mailto:support.fne@dgi.gouv.ci"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ 'support.fne@dgi.gouv.ci' }}
              </a>
            </strong>
          </p>
          <p>
            🌐 Consultez notre FAQ :
            <strong>
              <a
                href="https://www.fne.dgi.gouv.ci/faq.php"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ 'https://www.fne.dgi.gouv.ci/faq.php' }}
              </a>
            </strong>
          </p>
        </address>
      </section>
      <section class="company-user-migration-modal__footer">
        <p>
          Merci de votre patience et bienvenue dans la nouvelle ère de la
          facturation électronique ! Direction Générale des Impôts - Plateforme
          FNE
        </p>
      </section>
    </article>
  </ng-container>

  <ng-container footer>
    <div class="company-user-migration-modal__actions">
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="onLogout()"
      >
        Se déconnecter du compte
      </button>
    </div>
  </ng-container>
</custom-modal-card>
